<template>
    <div>
        <p>Graph's from Redash</p>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>